import React from "react";
import { Box, Spinner, Text, VStack } from "@chakra-ui/react";
import { useBusinesses } from "../../store/hooks/useBusinesses";
import { useCustomTheme } from "../../contexts/CustomThemeContext";
import BusinessCircleCarousel from "./BusinessCircleCarousel";
import GlobalSpinner from "../CustomReusables/GlobalSpinner";

interface BusinessesSectionProps {
  title?: string;
  subtitle?: string;
}

const cardsBorderRadii ="8px";

const BusinessesSection: React.FC<BusinessesSectionProps> = ({
  subtitle = "Explore shops, hosts, trip providers, and car hire owners.",
}) => {
  const { theme } = useCustomTheme();
  const { businesses, loading } = useBusinesses();

  if (loading) {
    return (
      <Box
        mt={8}
        p={4}
        bg={theme.surface}
        border={`1px solid ${theme.border}`}
        borderRadius={cardsBorderRadii}
      >
        <GlobalSpinner />
      </Box>
    );
  }

  if (!businesses.length) {
    return null;
  }

  return (
    <Box mt={3}>
      <VStack align="stretch" spacing={3} mb={4}>
        <Text color={theme.textMuted}>{subtitle}</Text>
      </VStack>

      <BusinessCircleCarousel
        items={businesses.map((business) => ({
          id: business.id,
          title: business.businessName || business.name || "Business",
          logoURL: business.logoURL,
          subtitle: business.role,
          navigateTo: `/search-details/businesses/${business.id}`,
        }))}
      />
    </Box>
  );
};

export default BusinessesSection;
